import { ReportType } from '../../../Types';
import { ReportActionTypes, SET_REPORT_TYPES } from './types';

export const setReportTypes = (reportTypes: ReportType[]): ReportActionTypes => ({
  type: SET_REPORT_TYPES,
  reportTypes
});
